import {createFetchableSlice} from '../../../utils/createFetchableSlice';
import {fetchInspections} from '../../../Api';

export const inspectionsSlice = createFetchableSlice({
    name: 'inspections',
    fetchable: fetchInspections,
});

export default inspectionsSlice.reducer;